module.exports = __webpack_public_path__ + "static/media/whoops.027194e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whoops.png
// module id = 598
// module chunks = 21